// extracted by mini-css-extract-plugin
export var item = "index-module--item--16BfO";
export var scroll = "index-module--scroll--2lFl1";
export var scrollShow = "index-module--scrollShow--AfqhH";